import { useMemo } from 'react';

import {
   TherapeuticGroupScheduleDaySimple,
   TherapeuticGroupServiceProvidingLocation,
} from '@dreryk/egabinet-group-session-frontend-api';

export const useUniqueLocations = (
   scheduleDays: TherapeuticGroupScheduleDaySimple[]
): TherapeuticGroupServiceProvidingLocation[] => {
   return useMemo(() => {
      const locationMap = new Map<string, TherapeuticGroupServiceProvidingLocation>();

      for (const day of scheduleDays) {
         const location = day.serviceProvidingLocation;
         locationMap.set(location.serviceLocationId.asString(), location);
      }

      return [...locationMap.values()];
   }, [scheduleDays]);
};
